import {Node, NodeSpec} from 'prosemirror-model'


import {schema} from "../../config/schema";


export interface FileAttrs {
    guid: string;
    src: string
    s3FileName: string
    title: string | null
}

export interface FileNode extends Node {
    attrs: FileAttrs
}

export const isFileNode = (node: Node): node is FileNode => {
    return node.type === schema.nodes.file;
}

export const file: NodeSpec = {
    group: 'inline',
    inline: true,
    attrs: {
        guid: { default: null },
        src: {default: null},
        s3FileName: {default: null},
        title: {default: null},
    },
    draggable: true,
    dragHandle: true,
    parseDOM: [
        {
            tag: '[data-node="file"]',
            getAttrs: (dom: HTMLElement): FileAttrs => {
                const element = dom as HTMLOListElement;
                return {
                    guid: element.getAttribute('data-guid') as string,
                    src: element.getAttribute('src') as string,
                    s3FileName: element.getAttribute('data-s3FileName') as string,
                    title: element.getAttribute('title'),
                }
            },
        },
    ],
    toDOM(node) {
        const {src, title} = node.attrs as FileAttrs;
        return [
            'a',
            {
                href: src,
                target: '_blank',
            },
            title,
        ];
    },
}
